import { Job } from '@readcloud/data';
import { jobsActions, useAppDispatch } from '@readcloud/state';
import { ClientSmallBrand } from '../../../types/TopToolbarConstants';
import { ExternalUrlModal } from './ExternalUrlModal';

type Props = {
  brand: ClientSmallBrand;
  bookId: string;
  cloudId: string;
  location: string;
  isOpen: boolean;
  toggle: () => void;
};

export const ConnectedExternalUrlModal = (props: Props) => {
  const dispatch = useAppDispatch();

  const onCopyToClipboard = (job: Job) => {
    dispatch(jobsActions.addJob(job));
  };

  return <ExternalUrlModal {...props} onCopy={onCopyToClipboard} />;
};
